import { styled } from "@mui/material/styles";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";

export const Wrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
}));

export const WrapperService = styled("section")(() => ({
  border: "1px solid #E4E7EC",
  borderRadius: "0.5rem",
  padding: "0.5rem",
}));

interface HeaderServiceProps {
  isExpanded?: boolean;
}
export const HeaderService = styled("header")(({ isExpanded }: HeaderServiceProps) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: isExpanded ? "0.6875rem" : 0,
}));

export const HeaderText = styled("span")(() => ({
  color: "#465869",
  font: "700 14px/21px Manrope",
}));

export const WrapperRightHeader = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "0.75rem",
}));

export const Icon = (isExpanded: boolean) =>
  styled(isExpanded ? MdKeyboardArrowUp : MdKeyboardArrowDown)(() => ({
    fontSize: 24,
    color: "#465869",
    cursor: "pointer",
  }));

export const List = styled("ul")(() => ({
  listStyle: "none",

  display: "flex",
  flexDirection: "column",
  gap: "0.6875rem",
}));

export const ListItem = styled("li")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 .5rem",
  "& span": {
    font: "500 14px/21px Manrope",
    color: "#465869",
    "&:first-of-type": {
      fontWeight: 700,
      color: "#308CDB",
    },
  },
}));
